  import React, { useContext, useEffect, useState, useRef } from 'react';
  import './AvailabilityTasks.scss';
  import {
    Box,
    Button,
    CircularProgress,
    Typography,
    Snackbar,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
  } from '@mui/material';
  import back from '../../assests/images/back.svg';
  import coins from '../../assests/images/coins.svg';
  import icon from '../../assests/images/step1-icon.svg';
  import uploadImg from '../../assests/images/uploadImg.svg';
  import UploadPack2 from '../../assests/images/cig_pack_img.svg';
  import CameraCapture from '../camera';
  import { useLocation, useNavigate } from 'react-router-dom';
  import { AuthContext, AuthContextType } from '../../context/AuthContext';
  import Icons from '../Icons';
  import i18n from '../../i18n';
  import { t } from 'i18next';
  import { KEY_STORE_ID } from '../../utils/contants';
  import closePackImg from '../../assests/images/resubmit_Img.svg';
  import coinSadLook from '../../assests/images/Coin_Mascot_sad_coin.svg';
  import { photoupload } from '../IRTask/api';
  import { translation_en } from '../../translations/translation_en';
  import { translation_hi } from '../../translations/translation_hi';

  type SeverityType = 'info' | 'error' | 'warning' | 'success';

  function isMobileDevice() {
    return /Mobi|Android/i.test(navigator.userAgent);
  }
const ANALYSIS_MAX_DIMENSION = 800;
const UPLOAD_MAX_DIMENSION = 1600;

  // Quality checks (blur/lighting) only need a small preview, not the full
  // camera-resolution image, to keep memory usage in check on low-RAM devices.
  
  function getScaledImageCanvas(img: HTMLImageElement) {
    const scale = Math.min(1, ANALYSIS_MAX_DIMENSION / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(img.width * scale));
    canvas.height = Math.max(1, Math.round(img.height * scale));
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
    return { canvas, ctx };
  }

  function ImageRecognization({ questData }: any) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const isSubmitting = useRef(false);
    const location = useLocation();
    const navigate = useNavigate();
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const authContext = useContext(AuthContext);
    const token = localStorage.getItem("token") || authContext?.token || "";
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const [selectedImageId, setSelectedImageId] = useState('');
    const apiCalledOnce = useRef(false);
    const encryptedTaskId = window.btoa(questData.data.task_id.toString());
    // const langKey = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";

//     const [langKey, setLangKey] = useState(
//   localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN"
// );
const DEFAULT_ICON =
  "https://pmi-api-prod.irepo.in/assets/sample_img6.png";
const langKey = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = langKey.startsWith("hi") ? translation_hi : translation_en;
useEffect(() => {
  i18n.changeLanguage(langKey);
}, [langKey]);
const buildImageUrl = (path?: string | null) => {
  if (!path) return null;

  // Already full URL → use directly
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  // Otherwise prefix FE base
  return `${process.env.REACT_APP_BASE_URL_image}${path}`;
};
const irtask = (translations as any)?.taskdetaitls?.availability || {};
const stepLabel = irtask.step_label ?? "Step";
const submit = irtask.submit ?? "Submit";
const retake = irtask.retake_photo_btn ?? "Retake";
    // const stepLabelMap: Record<string, string> = {
    //   en_IN: "Step",
    //   hi_IN: "कदम",
    //   mr_IN: "पाऊल",
    //   bn_IN: "ধাপ",
    //   ta_IN: "படி",
    //   te_IN: "దశ",
    // };
  //   const label =
  // translations?.taskdetaitls?.dot_code_scanning?.sample_img_label ??
  // "Please click on the button below to scan up to 50 packs";


    // const stepLabel = stepLabelMap[langKey] || stepLabelMap["en_IN"];
        // const stepLabel = stepLabelMap[langKey] || stepLabelMap.en_IN;


const [label, setLabel] = useState<string[]>([
  "sample_img_label",
  "sample_img_label",
]);

    console.log("📦 langKey from localStorage:", label);
    const [approvalStatus, setApprovalStatus] = useState(questData.data.approval_status);
    const [lastUploadedImageUrl, setLastUploadedImageUrl] = useState('');
    const [orientationModalOpen, setOrientationModalOpen] = useState(false);
    const [selectedOrientation, setSelectedOrientation] = useState<'portrait' | 'landscape' | null>(null);
    const [showBlurOverlay, setShowBlurOverlay] = useState(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    // New state for live tilt warnings   
    const [isTilted, setIsTilted] = useState(false);

    const handleOpenOrientationModal = () => {
      setOrientationModalOpen(true);
      setIsSubmitDisabled(false);  // reset on modal open
    };

    const handleCloseOrientationModal = () => {
      setOrientationModalOpen(false);
      setIsSubmitDisabled(false);  // reset on modal close
    };
    // Notification queue & current notification for sequential display
    const [notificationQueue, setNotificationQueue] = useState<
      { message: string; severity: SeverityType }[]
    >([]);
    const [currentNotification, setCurrentNotification] = useState<{
      open: boolean;
      message: string;
      severity: SeverityType;
    }>({ open: false, message: '', severity: 'info' });
    useEffect(() => {
      // Try to auto-open camera when component mounts
      fileInputRef.current?.click();
    }, []);
    // Notification helpers
    const enqueueNotification = (message: string, severity: SeverityType) => {
      setNotificationQueue((prev) => [...prev, { message, severity }]);
      // DO NOT set isSubmitDisabled here — only set when notification is displayed.
    };

    useEffect(() => {
      if (!currentNotification.open && notificationQueue.length > 0) {
        const next = notificationQueue[0];
        setCurrentNotification({
          open: true,
          message: next.message,
          severity: next.severity,
        });

        // set submit disabled only while an ERROR notification is being shown
        if (next.severity === 'error') {
          setIsSubmitDisabled(true);
        }

        setNotificationQueue((prev) => prev.slice(1));
      }
    }, [notificationQueue, currentNotification.open]);

    const handleCloseNotification = (
      _event?: React.SyntheticEvent | Event,
      reason?: string
    ) => {
      if (reason === 'clickaway') {
        // don't close on clickaway (optional) — but still keep current state
        return;
      }
      setCurrentNotification((prev) => ({ ...prev, open: false }));
      // Re-enable submit when notification is dismissed
      setIsSubmitDisabled(false);
    };

    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const params: any = {};
      queryParams.forEach((value, key) => {
        params[key] = value;
      });

      if (
        params['task_id'] &&
        params['session_id'] &&
        params['no_of_images'] &&
        params['Subtask_id'] &&
        !apiCalledOnce.current
      ) {
        apiCalledOnce.current = true;
        const taskData = [
          {
            task_id: window.atob(params['task_id']),
            question_id: window.atob(params['Subtask_id']),
            answer: params['session_id'],
            no_of_attempts: '1',
            is_correct: '',
          },
        ];
        setImages(taskData);
        handleSubmit(taskData);
      }
    }, [location]);

    const tasks =
      questData?.data?.subtasks?.map((subtask: any, index: number) => ({
        subtitle: subtask?.question,
        question_id: subtask?.question_id,
        sampleImage: buildImageUrl(subtask?.hint?.sample_image),
        task_id: subtask?.task_id,
        reward:
          questData?.data.bonus_point > 0
            ? `${t('earn_pnts.points_earn_diwali', {
              points: subtask.points || 0,
              bonus: questData?.data.bonus_point || 0,
            })}`
            : `${t('earn_pnts.points_earn', { points: subtask.points || 0 })}`,
        steps:
          subtask?.hint?.steps?.map((step: any) => ({
            step: `${stepLabel} ${step.step_number}`,
            description: step.step_text,
            icon: buildImageUrl(step?.step_icon),
          })) || [],
        sample_picture:
          subtask?.hint?.sample_image || (index === 0 ? uploadImg : UploadPack2),
        takeAPic: subtask?.options[0].option_value,
      })) || [];

    const [imagesCaptured, setImagesCaptured] = useState<boolean[]>(Array(tasks.length).fill(false));
    const [images, setImages] = useState<
      Array<{
        task_id: string;
        question_id: string;
        answer: string;
        no_of_attempts: string;
        is_correct: string;
      }>
    >([]);

    const handleCapture = (index: number, captured: boolean, question_id: string) => {
      const updatedImages = [...imagesCaptured];
      const labels = [...label];
      updatedImages[index] = captured;
      labels[index] = t('taskdetaitls.availability.clicked_img_label');
      setImagesCaptured(updatedImages);
      //setLabel(labels);
    };
useEffect(() => {
  console.log("✅ label state updated:", label);
}, [label]);

    const handleSubmit = async (images: any) => {
      setLoading(true);
      if (authContext) {
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/answer/store-answer`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Accept-Language': i18n.language,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(images),
          });

          if (!response.ok) {
            throw new Error('Failed to store answers');
          }

          await response.json();
          navigate(`/points/${encryptedTaskId}`);
        } catch (error) {
          console.error('Error submitting answer', error);
        } finally {
          setLoading(false);
        }
      }
    };

    const handleContinue = () => {
      setApprovalStatus(false);
    };

    // Tilt detection notification with live overlay support
    useEffect(() => {
      const handleTilt = (event: DeviceOrientationEvent) => {
        if (Math.abs(event.gamma || 0) > 20) {
          setIsTilted(true);
        } else {
          setIsTilted(false);
        }
      };
      window.addEventListener('deviceorientation', handleTilt, true);
      return () => window.removeEventListener('deviceorientation', handleTilt);
    }, []);

    // Helper functions for image checks (same as original)
    const checkOrientation = (file: File): Promise<'portrait' | 'landscape'> => {
      return new Promise((resolve) => {
        const img = new window.Image();
        img.onload = () => {
          resolve(img.width > img.height ? 'landscape' : 'portrait');
        };
        img.src = URL.createObjectURL(file);
      });
    };

    const checkBlur = (file: File): Promise<boolean> => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const { canvas, ctx } = getScaledImageCanvas(img);
          const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
          if (!imageData) return resolve(false);
          let sum = 0,
            count = 0;
          for (let i = 0; i < imageData.data.length; i += 4 * 500) {
            const r = imageData.data[i],
              g = imageData.data[i + 1],
              b = imageData.data[i + 2];
            sum += (r + g + b) / 3;
            count++;
          }
          const avg = sum / count;
          let variance = 0;
          for (let i = 0; i < imageData.data.length; i += 4 * 500) {
            const r = imageData.data[i],
              g = imageData.data[i + 1],
              b = imageData.data[i + 2];
            const brightness = (r + g + b) / 3;
            variance += Math.pow(brightness - avg, 2);
          }
          variance = variance / count;
          resolve(variance < 500); // low variance = blurry
        };
        img.src = URL.createObjectURL(file);
      });
    };

    const checkLighting = (file: File): Promise<'dark' | 'bright' | 'normal'> => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const { canvas, ctx } = getScaledImageCanvas(img);
          const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
          if (!imageData) return resolve('normal');
          let sum = 0;
          for (let i = 0; i < imageData.data.length; i += 4 * 1000) {
            const r = imageData.data[i],
              g = imageData.data[i + 1],
              b = imageData.data[i + 2];
            sum += (r + g + b) / 3;
          }
          const avg = sum / (imageData.data.length / (4 * 1000));
          if (avg < 50) return resolve('dark');
          if (avg > 200) return resolve('bright');
          return resolve('normal');
        };
        img.src = URL.createObjectURL(file);
      });
    };

  const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      // ---- Step 1: decode DOWNSAMPLED directly for analysis ----
      // (no full-resolution decode happens here at all)
      const analysisBitmap = await createImageBitmap(file, {
        resizeWidth: ANALYSIS_MAX_DIMENSION,
        resizeQuality: 'medium',
      });

      const orientation: 'portrait' | 'landscape' =
        analysisBitmap.width > analysisBitmap.height ? 'landscape' : 'portrait';

      if (selectedOrientation && orientation !== selectedOrientation) {
        enqueueNotification(
          `⚠️ Image taken in ${orientation}. Please use ${selectedOrientation} mode.`,
          'warning'
        );
      }

      const canvas = document.createElement('canvas');
      canvas.width = analysisBitmap.width;
      canvas.height = analysisBitmap.height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(analysisBitmap, 0, 0);
      const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);

      // 🔧 free the decoded bitmap immediately, don't wait for GC
      analysisBitmap.close();

      let isBlur = false;
      let lighting: 'dark' | 'bright' | 'normal' = 'normal';

      if (imageData) {
        // blur calc (same math as before)
        let sum = 0, count = 0;
        for (let i = 0; i < imageData.data.length; i += 4 * 500) {
          const r = imageData.data[i], g = imageData.data[i + 1], b = imageData.data[i + 2];
          sum += (r + g + b) / 3;
          count++;
        }
        const avg = sum / count;
        let variance = 0;
        for (let i = 0; i < imageData.data.length; i += 4 * 500) {
          const r = imageData.data[i], g = imageData.data[i + 1], b = imageData.data[i + 2];
          const brightness = (r + g + b) / 3;
          variance += Math.pow(brightness - avg, 2);
        }
        variance = variance / count;
        isBlur = variance < 500;

        // lighting calc (same math as before)
        let sum2 = 0;
        for (let i = 0; i < imageData.data.length; i += 4 * 1000) {
          const r = imageData.data[i], g = imageData.data[i + 1], b = imageData.data[i + 2];
          sum2 += (r + g + b) / 3;
        }
        const avg2 = sum2 / (imageData.data.length / (4 * 1000));
        lighting = avg2 < 50 ? 'dark' : avg2 > 200 ? 'bright' : 'normal';
      }

      setShowBlurOverlay(isBlur);

      if (lighting === 'dark') {
        enqueueNotification('⚠️ The photo is too dark. Please take in better light.', 'warning');
      } else if (lighting === 'bright') {
        enqueueNotification('⚠️ The photo is too bright. Avoid glare.', 'warning');
      }

      // ---- Step 2: decode DOWNSAMPLED again, separately, at upload size ----
      // Still far smaller than the original native resolution, so this
      // stays cheap even though it's a second decode of the same file.
      const uploadBitmap = await createImageBitmap(file, {
        resizeWidth: UPLOAD_MAX_DIMENSION,
        resizeQuality: 'medium',
      });

      const uploadCanvas = document.createElement('canvas');
      uploadCanvas.width = uploadBitmap.width;
      uploadCanvas.height = uploadBitmap.height;
      const uploadCtx = uploadCanvas.getContext('2d');
      uploadCtx?.drawImage(uploadBitmap, 0, 0);

      // 🔧 free this bitmap immediately too
      uploadBitmap.close();

      const compressedBlob: Blob | null = await new Promise((resolve) =>
        uploadCanvas.toBlob((b) => resolve(b), 'image/jpeg', 0.8)
      );

      if (!compressedBlob) {
        enqueueNotification('❌ Failed to process image. Please retake.', 'error');
        return;
      }

      const compressedFile = new File([compressedBlob], file.name, { type: 'image/jpeg' });

      setSelectedFile(compressedFile);
      const localPreviewUrl = URL.createObjectURL(compressedBlob);
      setPreviewImageUrl(localPreviewUrl);
      setLastUploadedImageUrl(localPreviewUrl);
    } catch (err) {
      // 🔧 CHANGE 3: whole flow wrapped in try/catch. If decoding still
      // fails on a very low-memory device, the user gets an in-app
      // error + a clean reset instead of a silent browser-level
      // reload/logout.
      console.error('Error processing captured image:', err);
      enqueueNotification('❌ Failed to process image. Please retake.', 'error');
      resetUploadStates();
    }
  };

    const resetUploadStates = () => {
      setSelectedFile(null);
      setPreviewImageUrl('');
      setSelectedImageId('');
      setShowBlurOverlay(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    };

    useEffect(() => {
      return () => {
        if (previewImageUrl) {
          URL.revokeObjectURL(previewImageUrl);
        }
      };
    }, [previewImageUrl]);

    const handleSubmit1 = async (retryCount = 0) => {
      if (isSubmitting.current) {
        console.log('handleSubmit1 already in progress, skipping');
        return;
      }

      isSubmitting.current = true;
      console.log('handleSubmit1 called with retryCount:', retryCount, {
        selectedFile: !!selectedFile,
        taskId: questData?.data?.task_id,
        questionId: tasks[0]?.question_id,
      });

      if (!selectedFile) {
        enqueueNotification('⚠️ Please upload an image first.', 'error');
        return;
      }
      if (!authContext) {
        enqueueNotification('❌ Authentication context is not available', 'error');
        return;
      }
      if (!tasks?.length || !questData?.data?.task_id) {
        enqueueNotification('❌ Missing task data. Please refresh and try again.', 'error');
        return;
      }

      if (!token) {
        enqueueNotification('❌ Authentication token is missing', 'error');
        return;
      }

      setLoading1(true);
      setLoading2(true);

      try {
        console.log(
          'Calling photoupload API with task_id:',
          questData.data.task_id,
          'question_id:',
          tasks[0].question_id
        );
        const uploadResult = await photoupload(
          selectedFile,
          questData.data.task_id,
          tasks[0].question_id,
          token
        );
        console.log('photoupload result:', JSON.stringify(uploadResult, null, 2));

        // if (uploadResult.success || uploadResult.status) {
        //   const imageId = uploadResult.data.apiResponse.image_id;
        //   const imageUrl = uploadResult.data.apiResponse.image_url;
        //   if (!imageId) {
        //     throw new Error('No imageId returned from photoupload');
        //   }
        //   console.log(
        //     '✅ Upload successful, imageId:',
        //     imageId,
        //     'imageUrl:',
        //     imageUrl || 'Not provided'
        //   );
        //   setSelectedImageId(imageId);
        //   handleCapture(0, true, tasks[0].question_id);

        //   const encryptedTaskId2 = window.btoa(questData.data.task_id.toString());
        //   navigate(`/points/${encryptedTaskId2}/${imageId}`);
        // } else {
        //   throw new Error(uploadResult.message || 'Upload failed');
        // }

        if (uploadResult.success || uploadResult.status) {
          const imageId = uploadResult.data.apiResponse.image_id;
          const imageUrl = uploadResult.data.apiResponse.image_url;

          if (!imageId) {
            throw new Error("No imageId returned from photoupload");
          }

          console.log(
            "✅ Upload successful, imageId:",
            imageId,
            "imageUrl:",
            imageUrl || "Not provided"
          );

          setSelectedImageId(imageId);
          handleCapture(0, true, tasks[0].question_id);

          /* ----------------------------------------------------
            ⭐ STEP 2: CALL IMAGE QUALITY VALIDATION API HERE ⭐
            ---------------------------------------------------- */
          // try {
          //   console.log("⏳ Waiting 3 seconds before validation...");
          //   await new Promise((resolve) => setTimeout(resolve, 5000)); // ⬅️ 3 sec delay

          //   setLoading2(true); // show loader during wait + validation API

          //   console.log("🔍 Calling image quality validation...");
          //   const qualityRes = await callImageQualityValidation(imageId, token);

          //   console.log("Image Quality Validation Response:", qualityRes);

          //   if (qualityRes?.success === false || qualityRes?.status === "fail") {
          //     enqueueNotification(
          //       qualityRes?.message || "❌ Image quality failed. Please retake the photo.",
          //       "error"
          //     );

          //     resetUploadStates();
          //     setLoading2(false);
          //     return; // stop flow
          //   }
          // } catch (err) {
          //   console.error("Image quality validation error:", err);
          //   enqueueNotification("❌ Unable to validate image quality. Retake the photo.", "error");
          //   resetUploadStates();
          //   setLoading2(false);
          //   return;
          // }

          /* ----------------------------------------------------
            ⭐ STEP 3: VALIDATION SUCCESS → PROCEED TO NEXT PAGE ⭐
            ---------------------------------------------------- */
          const encryptedTaskId2 = window.btoa(questData.data.task_id.toString());
          // navigate(`/points/${encryptedTaskId2}/${imageId}`);
          navigate(`/points/${encryptedTaskId}/${imageId}?isIR=true`);

        } else {
          throw new Error(uploadResult.message || "Upload failed");
        }

      } catch (error: any) {
        console.error(
          `Error in handleSubmit1 (retry ${retryCount}):`,
          error.message,
          error.stack
        );
        alert(`❌ Failed to process image: ${error.message}. Please retake the photo.`);

        if (retryCount < 2) {
          console.log(`Retrying... attempt ${retryCount + 1}`);
          await handleSubmit1(retryCount + 1);
        } else {
          console.log('Max retries reached, resetting upload states');
          resetUploadStates();
        }
      } finally {
        setLoading1(false);
        setLoading2(false);
        isSubmitting.current = false;
      }
    };

    useEffect(() => {
      console.log('Button state:', {
        selectedFile: !!selectedFile,
        loading1,
        loading2,
        disabled: !selectedFile || loading1 || loading2,
      });
    }, [selectedFile, loading1, loading2]);


    const handleOpenCamera = () => {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: "environment" } })
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
          }
        })
        .catch((err) => {
          console.error("❌ Camera access denied:", err);
          alert("Camera permission blocked. Please enable it in browser settings.");
        });
    };


    // const langKey1 = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
    

    // Map each locale key to its respective description
    const descMap: Record<string, string> = {
      en_IN: questData?.data?.task_desc_en,
      hi_IN: questData?.data?.task_desc_hi,
      mr_IN: questData?.data?.task_desc_mr,
      bn_IN: questData?.data?.task_desc_bn,
      ta_IN: questData?.data?.task_desc_ta,
      te_IN: questData?.data?.task_desc_te,
    };
    const descKey =
  descMap[langKey]
    ? langKey
    : `${langKey.split("_")[0]}_IN`;


    const taskDescription = descMap[descKey] || questData?.data?.task_desc_en || "";
    return (
      <Box>
        {/* Orientation Modal */}
        <Dialog
          open={orientationModalOpen}
          onClose={() => setOrientationModalOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: 3,
              padding: 2,
            },
          }}
        >
          <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            Choose the orientation of your picture taking
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={4} justifyContent="center">
              <Grid item>
                <Box
                  sx={{
                    cursor: 'pointer',
                    textAlign: 'center',
                    padding: 2,
                    borderRadius: 2,
                    border: '2px solid #E0E0E0',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                      borderColor: '#C8172F',
                    },
                  }}
                  onClick={() => {
                    setSelectedOrientation('portrait');
                    setOrientationModalOpen(false);
                    fileInputRef.current?.click();
                  }}
                >
                  {/* Portrait Icon */}
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      backgroundColor: '#F0F0F0',
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 8px',
                    }}
                  >
                    <Box sx={{ fontSize: '32px' }}>📱</Box>
                  </Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    PORTRAIT
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <Box
                  sx={{
                    cursor: 'pointer',
                    textAlign: 'center',
                    padding: 2,
                    borderRadius: 2,
                    border: '2px solid #E0E0E0',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                      borderColor: '#C8172F',
                    },
                  }}
                  onClick={() => {
                    setSelectedOrientation('landscape');
                    setOrientationModalOpen(false);
                    fileInputRef.current?.click();
                  }}
                >
                  {/* Landscape Icon */}
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      backgroundColor: '#F0F0F0',
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 8px',
                    }}
                  >
                    <Box sx={{ fontSize: '32px', transform: 'rotate(90deg)' }}>📱</Box>
                  </Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    LANDSCAPE
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        {approvalStatus === 'rejected' ? (
          <Box sx={{ margin: '24px 20px 0' }}>
            {/* Rejected status UI */}
            <Box
              sx={{
                padding: '18px 16px',
                background:
                  'linear-gradient(110deg, rgba(255, 248, 187, 0.00) 38.52%, rgba(220, 220, 106, 0.32) 100%), #FFF;',
                borderRadius: '10px',
                border: '1px solid rgba(250, 212, 102, 0.00)',
                textAlign: 'start',
                marginBottom: '20px',
                position: 'relative',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', maxWidth: '210px' }}>
                <Typography
                  sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: '500',
                    color: '#282829',
                  }}
                >
                  {t('status')} :
                </Typography>
                <Typography
                  sx={{
                    fontSize: '24px',
                    lineHeight: '32px',
                    fontWeight: '600',
                    color: '#F38305',
                    textTransform: 'capitalize',
                    marginLeft: '6px',
                  }}
                >
                  {t('rejected')}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: '12px',
                  lineHeight: '16px',
                  fontWeight: '400',
                  color: '#7D7E7F',
                  letterSpacing: '-0.06px',
                  maxWidth: '210px',
                }}
              >
                {t('uh_no_resubmit')}
              </Typography>
              <img
                style={{
                  maxWidth: '95px',
                  position: 'absolute',
                  width: '100%',
                  top: '12px',
                  right: '6px',
                  left: 'inherit',
                  height:"60px",
                  objectFit:"contain"
                }}
                src={questData.data.answer}
                crossOrigin="anonymous"
                alt="Default"
                width="100%"
              />
            </Box>
            <Box className="foot">
              <Button type="submit" className="btn_red" onClick={handleContinue}>
                {t('taskdetaitls.availability.continue')}
              </Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ paddingBottom: '90px' }}>
            <Box
              sx={{
                borderRadius: '16px',
                border: '1px solid rgba(250, 212, 102, 0.00)',
                background:
                  'linear-gradient(110deg, rgba(255, 248, 187, 0.00) 38.52%, rgba(220, 220, 106, 0.32) 100%), #FFF',
                paddingLeft: '16px',
                margin: '16px 20px 0 20px',
                textAlign: 'left',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ padding: '18px 0' }}>
                <Typography
                  variant="caption1"
                  sx={{
                    color: '#7D7E7F',
                    letterSpacing: '0.24px',
                    textTransform: 'uppercase',
                    fontWeight: '600',
                  }}
                >
                  Task
                </Typography>
                <div
                  style={{ fontWeight: '600', letterSpacing: '0.16px', fontSize: '14px' }}
                  dangerouslySetInnerHTML={{ __html: taskDescription }}
                />
              </Box >
              {/* <Box sx={{padding:'20px 10px'}}><img src="https://llp-pmi-prod-assets.s3.ap-south-1.amazonaws.com/assets/brand-disabled.svg" width={155} height={55} /> </Box> */}
            </Box>

            {/* Camera Guidance Message */}
            {selectedOrientation && (
              <Box
                sx={{
                  mt: 2,
                  mb: 1,
                  mx: 2,
                  p: 2,
                  background: '#E3F2FD',
                  borderRadius: 2,
                  border: '1px solid #2196F3',
                  textAlign: 'center',
                }}
              >
                <Typography variant="subtitle1" color="#1976D2" fontWeight="600">
                  📱 Camera Guidance
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  {isMobileDevice()
                    ? `For best results, please hold your phone in ${selectedOrientation.toUpperCase()} mode when taking the photo.`
                    : `For desktop, please select or capture an image in ${selectedOrientation.toUpperCase()} orientation.`}
                </Typography>
              </Box>
            )}

            {tasks.map((task: any, index: any) => (
              <Box
                key={index}
                sx={{
                  background: '#FFFFFF',
                  borderRadius: '12px',
                  margin: '20px',
                  textAlign: 'left',
                }}
              >
                <Box
                  className="cardHead"
                  sx={{
                    borderBottom: '1px dashed #C5C6C7',
                    display: 'flex',
                    padding: '16px 10px',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Typography variant="body2" sx={{ width: '160px' }}>
                    {task.subtitle !== '' ? (
                      <>
                        {`${t('taskdetaitls.availability.picture')} ${index + 1}`} :
                        <span style={{ marginLeft: '0px', display: 'inline-block' }}>{task.subtitle}</span>
                      </>
                    ) : (
                      `${t('taskdetaitls.availability.picture')} ${index + 1}`
                    )}
                  </Typography>
                  <Box
                    sx={{
                      borderRadius: '40px',
                      border: '1px solid #E8E8E8',
                      background: '#F5F6F7',
                      display: 'flex',
                      padding: '4px 8px',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <img src={coins} alt="" />
                    <Typography variant="caption1" sx={{ fontWeight: '700' }}>
                      {task.reward}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    padding: '12px 16px 0px 16px',
                    gap: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  {task.steps.map((step: any, stepIndex: any) => (
                    <Box
                      key={stepIndex}
                      sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                    >
                      <Box
                        sx={{
                          width: '100%',
                          maxWidth: '56px',
                          height: '56px',
                          backgroundColor: '#FFEBEF',
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
  crossOrigin="anonymous"
  src={step?.icon || "/default-icon.png"}
  alt="Step Icon"
/>
                      </Box>
                      <Box sx={{ textAlign: 'left' }}>
                        <Typography
                          variant="caption1"
                          sx={{ color: '#7D7E7F', fontWeight: '600' }}
                        >
                          {step.step}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 600, lineHeight: 'normal' }}
                          dangerouslySetInnerHTML={{ __html: step.description }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: '700',
                    letterSpacing: '0.14px',
                    padding: '16px 10px',
                    borderBottom: '1px dashed #C5C6C7',
                    marginTop: '8px',
                  }}
                >
                  {
  translations?.taskdetaitls?.dot_code_scanning?.[
    label[index] as keyof typeof translations.taskdetaitls.dot_code_scanning
  ] || label[index]
}



                </Typography>
                <Box sx={{ position: 'relative', padding: '12px 16px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '16px',
                      background: '#F5F6F7',
                      position: 'relative',
                    }}
                  >
                    <img
  style={{ objectFit: "cover" }}
  crossOrigin="anonymous"
  src={
    previewImageUrl ||
    lastUploadedImageUrl ||
    task.sampleImage ||
    DEFAULT_ICON
  }
  alt="Selected or last uploaded or default image"
  width="100%"
/>
                    {/* Blur Overlay */}
                    {showBlurOverlay && previewImageUrl && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          bgcolor: 'rgba(0,0,0,0.7)',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '16px',
                          zIndex: 2,
                          flexDirection: 'column',
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                          📷 Photo is blurry!
                        </Typography>
                        <Typography variant="body2" sx={{ textAlign: 'center' }}>
                          Please retake a clearer photo
                        </Typography>
                      </Box>
                    )}

                    {/* Live Tilt Overlay on camera or image */}
                    {isTilted && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          bgcolor: '#FFC107',
                          px: 2,
                          py: 1,
                          borderRadius: '16px',
                          color: '#000',
                          fontWeight: 'bold',
                          zIndex: 3,
                        }}
                        aria-live="assertive"
                      >
                        ⚠️ Your device is tilted, please hold straight.
                      </Box>
                    )}
                  </Box>

                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                  />

                  <Button
                    sx={{
                      display: 'block',
                      textAlign: 'center',
                      color: '#FFFFFF',
                      fontSize: '14px',
                      fontWeight: '700',
                      lineHeight: '21px',
                      letterSpacing: '0.12px',
                      borderRadius: '8px',
                      border: '1px solid #C8172F',
                      background: '#C8172F !important',
                      padding: '1px 24px',
                      marginTop: '8px',
                      minWidth: '100%',
                      textTransform: 'inherit',
                      height: '44px',
                      '&:hover': {
                        background: '#C8172F',
                        color: '#FFF',
                      },
                    }}
                    onClick={() => {
                      console.log('Take/Retake Photo button clicked');
                      setOrientationModalOpen(true);
                      handleOpenCamera();
                    }}
                    disabled={loading1 || loading2}
                  >
                    {/* {loading2 ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : selectedFile ? (
                      `${retake}`
                    ) : (
                      t('taskdetaitls.availability.take_photo_btn')
                    )} */}
                    {selectedFile
  ? retake
  : t('taskdetaitls.availability.take_photo_btn')}
                  </Button>
                </Box>
              </Box>
            ))}
            {/* Notification Snackbar for other notifications */}
            <Snackbar
              open={currentNotification.open}
              autoHideDuration={
                currentNotification.message.includes("portrait") ? null : 4000
              } // stays open if it's the portrait error
              onClose={handleCloseNotification}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert
                onClose={handleCloseNotification}
                severity={currentNotification.severity}
                sx={{ width: "100%" }}
              >
                {currentNotification.message}
              </Alert>
            </Snackbar>



            <Box sx={{ margin: '30px' }}>
              {selectedFile && (
                <Button
                  fullWidth
                  variant="contained"
                  disabled={loading2 || isSubmitDisabled}
                  onClick={() => {
                    console.log('Submit button clicked');
                    handleSubmit1();
                  }}
                  sx={{
                    background: '#C8172F !important',
                    color: '#fff',
                    textTransform: 'none',
                    fontSize: 16,
                    fontWeight: 600,
                    borderRadius: 2,
                    boxShadow: 'none',
                    py: 1,
                    height: '44px',
                  }}
                >
                  {loading1 ? <CircularProgress size={20} color="inherit" /> : `${submit}`}
                </Button>
              )}
            </Box>

          </Box>
        )}





      </Box>
    );
  }

  export default ImageRecognization;
